import { TopNav } from "./TopNav";
import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AccountHolder } from "./Account";
import { AddToListControl } from "@tlc/ls2pac/app/controls/AddToListControl";
import { RequestsView } from "@tlc/ls2pac/app/views/RequestsView";
import { WriteReviewControl } from "@tlc/ls2pac/app/controls/writeReviewControl";
import { BT_EResourceRequestView } from "@tlc/ls2pac/app/views/BT_EResourceRequestView";
import { removeCookie } from "typescript-cookie";

export async function rootLoader() {
  return await AccountHolder.fetchAccountData();
}

export const Root: React.FC = () => {
  const location = useLocation();

  const showSearchForm =
    location.pathname === "/" ||
    location.pathname === "/search" ||
    location.pathname.indexOf("section") !== -1;

  React.useEffect(() => {
    removeCookie("SAVED_DESTINATION"); // remove SAVED_DESTINATION on page load
    const addToListControl = new AddToListControl();
    RequestsView.init();
    new BT_EResourceRequestView();
    WriteReviewControl.init();
    return () => {
      addToListControl?.cleanup();
    };
  }, []);

  return (
    <>
      {/* add  */}
      {/* <TopNav showSearchForm={showSearchForm} color="primary"></TopNav> */}
      <TopNav showSearchForm={showSearchForm}></TopNav>
      <Outlet></Outlet>
    </>
  );
};
